import { HelmetDexteel } from "@dexteel/mesf-core";
import { ForecastReportManager } from "./components/ForecastReportManager";

export const ForecastReportPage = () => {
	return (
		<>
			<HelmetDexteel title="Forecast Report" />
			<ForecastReportManager />
		</>
	);
};
